/* eslint-disable no-unused-expressions, no-unused-vars */
import { PrinterSetup } from "../src/printer/printer_setup";
import { QZService } from "../src/printer/qz_service";
import Swal from "sweetalert2";

window.Swal = Swal;
window.PrinterSetup = PrinterSetup;
window.QZService = QZService;
